import { useContext } from 'react';
import { EntityContext } from '.';
import { IEntityContext } from './types';

export const useEntityContext = (): IEntityContext => useContext(EntityContext);
